import { fromJS } from 'immutable';

import { ABORT_CURRENT_TASKS } from 'phoenix2/state/common/actions';
import { START_ALERT, END_ALERT } from './actions';

export const ALERT_KEY = 'alert';
export const TUTORIAL_BUBBLE_KEY = 'tutorial';
export const TUTORIAL_KEYS = [
    'wrongAnswerTutorial',
    'watchVideoTutorial',
    'wacTutorial',
    'multiPartQuestionTutorial',
];

// There are currently two ways to end an alert - END_ALERT, which is
// usually trigger by the user pressing a button to dismiss the alert, and
// ABORT_CURRENT_TASKS which is called to forcibly dismiss all alerts when
// the app needs to move into a new state (e.g. switching tasks in lessons
// mode)

export function alertReducer(state = null, action) {
    switch (action.type) {
        case START_ALERT:
            return fromJS(action.alert);
        case END_ALERT:
            return null;
        case ABORT_CURRENT_TASKS:
            return null;
    }
    return state;
}
